/**
 * The lead tile of each row in the right panel's grouped property cards: which glyph it shows and
 * which solid colour it sits on. One map, so a row looks the same on every screen type and host.
 *
 * Tones are named by hue and resolve in `property-row-icon.scss` to the `--avatar-*` hues (and
 * `--tile-neutral` for the one grey row): those are the only colours fixed across both themes that
 * hold 4.5:1 under a white glyph, where a ramp step such as `--purple-4` inverts between themes.
 */
export type PropertyRowKind =
  | "role"
  | "masterScreen"
  | "stepScreen"
  | "offline"
  | "pullToRefresh"
  | "dataCache"
  | "authorization"
  | "visibility"
  | "editability"
  | "pressEnter"
  | "shortcuts"
  | "documentParameters"
  | "watermark";

export type PropertyRowTone =
  | "violet"
  | "purple"
  | "blue"
  | "cyan"
  | "teal"
  | "sea"
  | "green"
  | "orange"
  | "pink"
  | "neutral";

export interface IPropertyRowIconInfo {
  /** Asset name under `public/images/common/`. */
  iconName: string;
  tone: PropertyRowTone;
}

export const PROPERTY_ROW_ICONS: Record<PropertyRowKind, IPropertyRowIconInfo> = {
  role: { iconName: "user", tone: "violet" },
  masterScreen: { iconName: "template", tone: "purple" },
  stepScreen: { iconName: "stairs", tone: "blue" },
  offline: { iconName: "wifi-off", tone: "neutral" },
  pullToRefresh: { iconName: "refresh", tone: "cyan" },
  dataCache: { iconName: "stack-2", tone: "sea" },
  authorization: { iconName: "shield", tone: "green" },
  visibility: { iconName: "eye", tone: "cyan" },
  editability: { iconName: "edit", tone: "teal" },
  pressEnter: { iconName: "corner-down-left", tone: "orange" },
  shortcuts: { iconName: "keyboard", tone: "pink" },
  documentParameters: { iconName: "tag", tone: "sea" },
  watermark: { iconName: "image", tone: "purple" }
};
